import * as angular from 'angular';

import { Workspace } from '../../models/Workspace';
import { ISessionStorageService } from './sessionStorage.service';
import * as constants from '../../common/constants';
import * as events from '../../common/events';

export interface IWorkspaceService {
    getWorkspace(): Workspace;
    setWorkspace(workspace: Workspace);
    clearWorkspace();
}

export class WorkspaceService implements IWorkspaceService {
    static serviceId = 'workspaceService';
    static $inject = ['sessionStorageService', '$rootScope'];
    
    constructor(
        private sessionStorageService: ISessionStorageService,
        private $rootScope: angular.IRootScopeService
    ) {

    }

    getWorkspace(): Workspace {
        let workspace;
        try {
            const asString = this.sessionStorageService.getFrom(constants.workspaceKey);
            if (asString) {
                workspace = JSON.parse(asString);
            }
        } catch (e) {
            // nothing?
        }
        return workspace;
    }

    setWorkspace(workspace: Workspace) {
        this.clearWorkspace();
        this.sessionStorageService.setTo(constants.workspaceKey, JSON.stringify(workspace));
    }

    clearWorkspace() {
        const existing = this.sessionStorageService.getFrom(constants.workspaceKey);
        if (existing) {
            this.sessionStorageService.remove(constants.workspaceKey);
            this.$rootScope.$broadcast(events.applicationConnected, null);
        }
    }
}